var icon_button_rtlignore_default = {
  "audioIconButton": "Ylhqx"
};
export {
  icon_button_rtlignore_default as default
};
//# sourceMappingURL=icon-button.rtlignore-scss.js.map
